import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ $rounded?: boolean }>`
  background-color: #fff;
  border-radius: ${({ $rounded }) => ($rounded ? '10px' : '0')};
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const HeaderInfo = styled.div``;

export const HeaderAction = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const HeaderTitle = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 0;
`;

export const HeaderSubtitle = styled.p`
  margin: 0.5rem 0 0;
  color: #7b7b80;
`;
